import React from 'react';
import ApprovalDashboard from './ApprovalDaboard';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import { useGetPermissions } from 'layouts/customHook';
import { approvalConfig } from '../shared/config';
import { useParams } from 'react-router';
const PmApprovalDashboardWrapper = () => {
    const { type } = useParams(); // cash | cheque

    const config = approvalConfig[type];

    const userPermissions = useGetPermissions(config.permissionKey);

    if (!config) {
        return <PermisionDenied />;
    }



    return userPermissions ? (
        <ApprovalDashboard
            type={type}
            userPermissions={userPermissions}
        />
    ) : (
        <PermisionDenied />
    );
};
export default PmApprovalDashboardWrapper;